module.exports = __webpack_public_path__ + "img/logo.c0b4e00b.png";